import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tracking-modal',
  templateUrl: './tracking-modal.component.html',
  styleUrls: ['./tracking-modal.component.scss']
})
export class TrackingModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
